<ng-container *ngIf="imgUrl || src">
  <!-- 传入自定义样式 -->
  <ng-container *ngIf="style">
    <ng-container  *ngIf="typeUtilService.isObject(style)">
      <div [ngStyle]="style">
        <img class="image" [src]="imgUrl || src" alt="" [ngStyle]="{ 'object-fit': objectFit }" (click)="handlePreview()" loading="lazy"/>
      </div>
    </ng-container>
    <ng-container  *ngIf="typeUtilService.isString(style)">
      <div [style]="style">
        <img class="image" [src]="imgUrl || src" alt="" [ngStyle]="{ 'object-fit': objectFit }" (click)="handlePreview()" loading="lazy"/>
      </div>
    </ng-container>
  </ng-container>
  <!-- 不传样式-图片默认按容器高宽 -->
  <ng-container *ngIf="!style">
    <img class="image" [src]="imgUrl || src" alt="" [ngStyle]="{ 'object-fit': objectFit }" (click)="handlePreview()" loading="lazy"/>
  </ng-container>
</ng-container>

<!-- 没图默认展示的内容 -->
<ng-container *ngIf="!imgUrl && !src">
  <ng-container *ngIf="typeUtilService.isObject(hint)">
    <ng-container [ngTemplateOutlet]="hint"></ng-container>
  </ng-container>
  <ng-container *ngIf="typeUtilService.isString(hint)">
    {{ hint ? hint : '' }}
  </ng-container>
</ng-container>

<ng-container *ngIf="!isDisablePreview">
  <nz-modal
    [nzStyle]="{ 'top': '150px', 'max-height': '500px' }"
    [nzVisible]="previewVisible"
    [nzContent]="modalContent"
    [nzFooter]="null"
    (nzOnCancel)="previewVisible = false"
    nzClosable="false"
  >
    <ng-template #modalContent>
      <img [src]="imgUrl" [ngStyle]="{ 'width': '100%', 'transform': 'scale('+scale+')' }" (mousewheel)="onMousewheel($event)" loading="lazy"/>
    </ng-template>
  </nz-modal>
</ng-container>
